exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form .form-bordered .form-group > div {\n    padding: 6px !important;\n}\n.md-checkbox label > .box {\n    height: 17px !important;\n    width: 17px !important;\n}\n#s2id_servicio ul {\n    max-height: 100px !important;\n    overflow-y: auto !important;\n}\n#s2id_comunidad ul {\n    max-height: 100px !important;\n    overflow-y: auto !important;\n}\n#s2id_status ul {\n    max-height: 100px !important;\n    overflow-y: auto !important;\n}\n", ""]);

// exports
